export const START_REVIEW_DECISION = "startReviewDecision";
export const startReviewDecision = (accepted, uniqueName, reason) => ({
    type: START_REVIEW_DECISION,
    accepted,
    uniqueName,
    reason
});

export const END_REVIEW_DECISION = "endReviewDecision";
export const endReviewDecision = () => ({
    type: END_REVIEW_DECISION
});